<template>
  <Header />
  <div :class="$style.container">
    <div :class="$style.content">
      <div :class="$style.top">
        <div :class="$style.name">
          {{
            $route.params.slug
              ? "Редактировать контрагента"
              : "Создать контрагента"
          }}
        </div>
        <img
          @click="$router.push('/counterparties')"
          src="/icons/big-cross.svg"
          alt=""
        />
      </div>
      <Filters for-creation />
      <div :class="$style.form">
        <Form :counterpartie="counterpartie" for-creation />
        <div :class="$style.files">
          <File v-for="file in files" :key="file.id" :file="file" />
        </div>
        <Employes />
        <Events :items="$store.state.counterparties.counterpartie.event_logs" />
      </div>
      <div :class="$style.buttons">
        <div :class="[$style.button, $style.file]">
          <input @change="setFile($event)" type="file" />
          Добавить реквизиты
        </div>
        <div @click="save" :class="[$style.button, $style.green]">
          Сохранить
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/layouts/Header.vue";
import Filters from "@/components/counterparties/Filters.vue";
import Form from "@/components/counterparties/Form.vue";
import Employes from "@/components/counterparties/Employes.vue";
import Events from "@/components/counterparties/Events.vue";
import File from "@/components/common/File.vue";
export default {
  components: {
    Header,
    Filters,
    Form,
    Employes,
    Events,
    File,
  },
  data() {
    return {
      errors: [],
    };
  },
  async mounted() {
    if (this.$route.params.slug) {
      await this.$store.dispatch("getCounterpartie", this.$route.params.slug);
    } else {
      this.$store.commit("resetCounterpartie");
    }
  },
  computed: {
    counterpartie() {
      return this.$store.state.counterparties.counterpartie;
    },
    files() {
      return this.$store.state.attachments.files;
    },
  },
  methods: {
    async save() {
      let files = [];
      this.files.forEach((i) => files.push(i.id));
      this.$store.commit("setCounterpartiesField", {
        field: "requisites",
        value: files,
      });
      if (this.$route.params.slug) {
        const resp = await this.$store.dispatch("updateCounterpartie");
        if (!resp) {
          this.errors = this.$store.state.errors.errors[0];
          return;
        }
      } else {
        const resp = await this.$store.dispatch("createCounterpartie");
        if (!resp) {
          this.errors = this.$store.state.errors.errors[0];
          return;
        }
      }

      this.$store.commit("resetErrors");
      this.$router.push("/counterparties");
    },
    remove(id) {
      this.$store.dispatch("deleteNotification", id);
    },
    setFile(e) {
      const formData = new FormData();
      formData.set("file", e.target.files[0]);
      this.$store.dispatch("createFile", formData);
    },
  },
};
</script>

<style lang="scss" module>
.container {
  padding: 1.5rem;
  .content {
    background-color: $bg-secondary;
    border-radius: 1rem;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 2rem;
      padding: 1.5rem 1.5rem 0 1.5rem;
      img {
        cursor: pointer;
      }
      .name {
        display: flex;
        align-items: center;
        gap: 1rem;
        flex: 1 1 auto;
        @include H2;
        .input {
          width: 100%;
          input {
            width: 100%;
            border: none;
            outline: 0;
            @include H2;
            &::placeholder {
              @include H2;
              color: $t-secondary;
            }
          }
          &.error {
            input {
              &::placeholder {
                color: $red;
              }
            }
          }
        }
      }
    }
    .form {
      padding: 1.5rem;
      background-color: $bg-primary;
      border-top: 1px solid $bg-separator;
      border-bottom: 1px solid $bg-separator;
      .bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 2rem;
        padding: 1.5rem 0 0 0;
        background-color: $bg-primary;
        .author {
          p {
            @include Body3;
            color: $t-secondary;
            margin: 0 0 0.25rem 0;
          }
          div {
            @include Title;
          }
        }
      }
      .files {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin: 1.5rem 0 0 0;
      }
      .notifications {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 1.5rem;
        margin: 1.5rem 0 0 0;
        .notification {
          background-color: $bg-secondary;
          padding: 0.75rem;
          border-radius: 0.25rem;
          > div {
            display: flex;
            align-items: center;
            color: $red-primary;
            gap: 0.5rem;
            margin: 0 0 0.75rem 0;
            position: relative;
            .cross {
              position: absolute;
              top: 0;
              right: 0;
              cursor: pointer;
            }
          }
        }
      }
    }
    .buttons {
      display: flex;
      justify-content: flex-end;
      padding: 1.5rem;
      gap: 1rem;
      .button {
        color: $t-secondary;
        padding: 0.75rem 1rem;
        border: 1px solid $t-secondary;
        border-radius: 6.25rem;
        @include ButtonText;
        cursor: pointer;
        &.green {
          color: $t-white;
          background-color: $main-green;
          border: 1px solid $main-green;
        }
        &.file {
          position: relative;

          input {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
